import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-enter-email',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './enter-email.component.html',
  styleUrls: ['./enter-email.component.scss'],
  host: { 'class': 'w-full block' }
})
export class EnterEmailComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  resetForm = new FormGroup({
    email: new FormControl('', { validators: [Validators.required, Validators.email], nonNullable: true })
  });

  isLoading = false;
  errorMessage = '';

  onSubmit() {
    if (this.resetForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      const email = this.resetForm.value.email;
      if (!email) return;
      
      this.authService.resetPasswordRequest(email).subscribe({
        next: () => {
          this.router.navigate(['/auth/reset-password/check-email'], {
            queryParams: { type: 'reset-password', email }
          });
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.errorMessage = err.error?.email?.[0] || 'Failed to request reset.';
        }
      });
    } else {
      this.resetForm.markAllAsTouched();
    }
  }
}
